import React from 'react'
import { isEmpty } from 'lodash-es'

import { IContestEntry } from 'protos'

import List from '@material-ui/core/List'
import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import T from 'components/FormattedMessage'
import Point from 'components/Point'
import GeneralListItem from 'components/GeneralListItem'

const styles = (theme: Theme) => createStyles({
  versus: {
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
  }
})

interface Props extends WithStyles<typeof styles> {
  details: IContestEntry['details']
}

const EventRankingItemDetails: React.SFC<Props> = ({ details, classes }) => {
  if (isEmpty(details)) {
    return null
  }

  return (
    <List style={{ padding: 0 }}>
      {details!.map((detail, i) => (
        <GeneralListItem
          key={`event-ranking-detail-${i}`}
          headline={
            <>
              <span>{detail.match && detail.match.homeTeam && detail.match.homeTeam.name}</span>
              <span className={classes.versus}><T id="game_defaultscore_upcoming" /></span>
              <span>{detail.match && detail.match.awayTeam && detail.match.awayTeam.name}</span>
            </>
          }
          rightChild={<Point value={detail.score} />}
        />
      ))}
    </List>
  )
}

export default withStyles(styles)(EventRankingItemDetails)
